module.exports = __webpack_public_path__ + "static/media/idea.4869b5d6.svg";